<template>
  <div>
    <Loading :loading="sending" />
    <div>
      <md-card-content>
        <p class="md-title">Gerar codigo de integração</p>
        <p class="md-error" style="color: #ff1744">
          * Não compartilhe esse codigo com ninguém!
        </p>
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-size-25">
            <md-field>
              <label for="codigoIntegracaoDescricao">Descrição</label>
              <md-input
                id="codigoIntegracaoDescricao"
                v-model="codigoIntegracao.descricao"
                name="codigoIntegracaoDescricao"
                type="text"
              />
            </md-field>
          </div>
          <div class="md-layout-item md-size-10">
            <md-button
              class="md-raised md-primary"
              @click="gerarCodigoIntegracaoEquipamento"
            >
              Gerar
            </md-button>
          </div>
          <div class="md-layout-item md-size-5 mt-2">
            <md-progress-spinner
              v-if="codigoIntegracao.loading"
              :md-diameter="30"
              :md-stroke="5"
              md-mode="indeterminate"
            />
          </div>
          <div class="md-layout-item md-size-10">
            <router-link
              :to="{
                name: 'CodigoIntegracaoEquipamento',
                params: {
                  equipamentoId: equipamentoId,
                  localId: localId,
                },
              }"
            >
              <md-button class="md-primary"> Visualizar códigos </md-button>
            </router-link>
          </div>
        </div>

        <div class="md-layout md-gutter">
          <div class="md-layout-item md-size-40">
            <md-field>
              <label for="codigoIntegracaoGerado">Codigo de Integração</label>
              <md-textarea
                id="codigoIntegracaoGerado"
                v-model="codigoIntegracao.codigo"
                name="codigoIntegracaoGerado"
                type="text"
                md-autogrow
                :disabled="true"
              />
            </md-field>
          </div>

          <div class="md-layout-item md-size-20">
            <md-button
              class="md-raised md-primary"
              @click="() => copiarCodigo(codigoIntegracao.codigo)"
            >
              Copiar
            </md-button>
          </div>
        </div>
      </md-card-content>
      <hr />
      <md-card-content>
        <p class="md-title">Obter código de integração por senha</p>
        <p class="md-error" style="color: #ff1744">
          * Não compartilhe esse codigo com ninguém!
        </p>
      </md-card-content>
      <md-card-content>
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-size-40">
            <md-field>
              <label for="senhaGenerata">Senha atual</label>
              <md-input
                id="senhaGenerata"
                v-model="gerarCodigo.senhaAtual"
                name="senhaGenerata"
                type="password"
                :disabled="sending"
                @change="gerarCodigoAuth"
              />
            </md-field>
          </div>
          <div class="md-layout-item md-size-40">
            <md-field>
              <label for="codigo">Codigo de autenticação</label>
              <md-input
                id="codigo"
                v-model="gerarCodigo.codigo"
                name="confirmarNovaSenha"
                type="text"
                :disabled="true"
              />
            </md-field>
          </div>
          <div class="md-layout-item md-size-20">
            <md-button
              class="md-raised md-primary"
              @click="() => copiarCodigo(gerarCodigo.codigo)"
            >
              Copiar código
            </md-button>
          </div>

          <md-divider />
        </div>
      </md-card-content>
    </div>
    <!-- SENHA para editar -->
    <form v-if="!sending" novalidate @submit.prevent="validateNewSenha">
      <md-card-content>
        <p class="md-title">Mudar senha do equipamento</p>
        <p class="md-error" style="color: #ff1744">
          * Cuidado ao alterar a senha, após a mudança terá que mudar o código
          no equipamento!
        </p>
      </md-card-content>
      <md-card-content>
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-small-size-100">
            <md-field :class="getValidationNewPassword('novaSenha')">
              <label for="novaSenha">Nova senha</label>
              <md-input
                id="novaSenha"
                v-model="changePassword.novaSenha"
                name="novaSenha"
                type="password"
                :disabled="sending"
              />
              <span
                v-if="!$v.changePassword.novaSenha.required"
                class="md-error"
                >Senha é obrigatório</span
              >
              <span
                v-if="!$v.changePassword.novaSenha.minLength"
                class="md-error"
                >Senha tamanho mínimo de 6 caracteres</span
              >
            </md-field>
          </div>

          <div class="md-layout-item md-small-size-100">
            <md-field :class="getValidationNewPassword('confirmarNovaSenha')">
              <label for="confirmarNovaSenha">Confirmar nova senha</label>
              <md-input
                id="confirmarNovaSenha"
                v-model="changePassword.confirmarNovaSenha"
                name="confirmarNovaSenha"
                type="password"
                :disabled="sending"
              />
              <span
                v-if="!$v.changePassword.confirmarNovaSenha.required"
                class="md-error"
                >Confirmar Senha é obrigatório</span
              >
            </md-field>
          </div>

          <md-divider />
        </div>
      </md-card-content>

      <p v-if="base64" class="md-title">
        * Novo código de acesso: Basic {{ base64 }}
      </p>

      <md-progress-bar v-if="sending" md-mode="indeterminate" />

      <md-card-actions>
        <md-button
          type="submit"
          class="md-primary md-raised"
          :disabled="sending"
        >
          Mudar senha
        </md-button>
      </md-card-actions>
    </form>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { minLength, required, sameAs } from 'vuelidate/lib/validators'

import Loading from '../../components/Loading'
import http from '../../utils/http'

export default {
  name: 'EquipamentoChangeCredentials',
  components: { Loading },
  mixins: [validationMixin],
  props: {
    localId: String,
    equipamentoUsuario: String,
    equipamentoId: String,
  },
  data() {
    return {
      codigoIntegracao: {
        loading: false,
        codigo: '',
        descricao: '',
      },
      gerarCodigo: {
        senhaAtual: null,
        codigo: null,
      },
      changePassword: {
        senha: null,
        novaSenha: null,
        confirmarNovaSenha: null,
      },
      base64: null,
      sending: false,
    }
  },
  validations: {
    changePassword: {
      novaSenha: {
        minLength: minLength(6),
        required,
      },
      confirmarNovaSenha: {
        required,
        sameAsPassword: sameAs('novaSenha'),
      },
    },
  },
  methods: {
    copiarCodigo(data) {
      const el = document.createElement('textarea')
      el.value = data
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
    },
    gerarCodigoAuth() {
      const base64Encode = btoa(
        `${this.equipamentoUsuario}:${this.gerarCodigo.senhaAtual}`
      )

      this.gerarCodigo.codigo = `Basic ${base64Encode}`
    },
    async handleSubmitChangeSenha() {
      this.sending = true

      await http.put('equipamento/password/reset', {
        newPassword: this.changePassword.novaSenha,
        confirmPassword: this.changePassword.confirmarNovaSenha,
        equipamentoId: this.equipamentoId,
      })

      this.sending = false

      this.base64 = btoa(
        `${this.form.usuario}:${this.changePassword.novaSenha}`
      )

      this.$emit('change')
    },
    getValidationNewPassword(fieldName) {
      const field = this.$v.changePassword[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty,
        }
      }
    },
    validateNewSenha() {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        this.handleSubmitChangeSenha()
      }
    },
    gerarCodigoIntegracaoEquipamento() {
      this.codigoIntegracao.loading = true

      http
        .post(`equipamento/integracao/gerar-codigo`, {
          localId: this.localId,
          equipamentoId: this.equipamentoId,
          descricao: this.codigoIntegracao.descricao,
        })
        .then((response) => {
          this.codigoIntegracao.codigo = response.codigoIntegracao
        })
        .finally(() => {
          this.codigoIntegracao.loading = false
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.left-zero {
  padding-left: 0;
  margin-left: 0;
  margin-right: 5% !important;
}
</style>
